module.exports = __webpack_public_path__ + "assets/img/m_bdt_img7.7b08357c.png";